import React from 'react';
import { Skeleton } from '../../../../../components/ComponentsV1/Skeleton/Skeleton';
import Button from '../../../../../components/ComponentsV1/Button';
import SopDetails from './SopDetails';
import SopUpdateForm from './SopUpdateForm';
import { SOP_STATUS, SKELETON_ROWS } from '../constants';

const SopSkeleton = () => (
  <div className='tw-bg-white tw-p-8 tw-rounded-2xl'>
    <Skeleton rows={SKELETON_ROWS} />
  </div>
);

const SopResult = ({
  sopStatus,
  sopData,
  isFetching,
  onUpdate,
  onDelete,
  onCreate,
  showDeleteConfirm,
  setShowDeleteConfirm,
  isUpdateMode,
  setIsUpdateMode,
  isActionLoading,
}) => {
  if (sopStatus === SOP_STATUS.NONE) {
    if (isFetching) return <SopSkeleton />;
    return null;
  }

  if (isFetching || isActionLoading) return <SopSkeleton />;

  if (sopStatus === SOP_STATUS.FOUND) {
    return (
      <div className='tw-bg-white tw-p-8 tw-rounded-2xl tw-flex tw-flex-col tw-gap-6'>
        <div className='tw-flex tw-items-center tw-gap-2 tw-text-[1.6rem] tw-font-medium tw-text-green-700'>
          SOP found
        </div>

        <SopDetails data={sopData} />

        {!isUpdateMode && !showDeleteConfirm && (
          <div className='tw-flex tw-gap-4'>
            <Button title='Update' onClick={() => setIsUpdateMode(true)} />
            <Button
              title='Delete'
              type='outline'
              onClick={() => setShowDeleteConfirm(true)}
            />
          </div>
        )}

        {isUpdateMode && (
          <SopUpdateForm
            sopData={sopData}
            isActionLoading={isActionLoading}
            onSave={onUpdate}
            onCancel={() => setIsUpdateMode(false)}
          />
        )}

        {showDeleteConfirm && (
          <div
            className='tw-border tw-border-solid tw-border-red-200 tw-bg-red-50 tw-rounded-lg tw-p-6'
            style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}
          >
            <div className='tw-text-[1.4rem] tw-font-medium tw-text-zinc-800'>
              Are you sure you want to delete this SOP?
            </div>
            <div className='tw-flex tw-gap-4'>
              <Button
                title='Cancel'
                type='outline'
                onClick={() => setShowDeleteConfirm(false)}
              />
              <Button title='Confirm Delete' onClick={onDelete} />
            </div>
          </div>
        )}
      </div>
    );
  }

  if (sopStatus === SOP_STATUS.NOT_FOUND && onCreate) {
    return (
      <div className='tw-bg-white tw-p-8 tw-rounded-2xl tw-flex tw-flex-col tw-gap-6'>
        <div className='tw-flex tw-items-center tw-gap-2 tw-text-[1.6rem] tw-font-medium tw-text-zinc-700'>
          SOP does not exist. You can create a new one.
        </div>

        {!isUpdateMode && (
          <div>
            <Button title='Create New SOP' onClick={() => setIsUpdateMode(true)} />
          </div>
        )}

        {isUpdateMode && (
          <SopUpdateForm
            sopData={null}
            isActionLoading={isActionLoading}
            onSave={onCreate}
            onCancel={() => setIsUpdateMode(false)}
          />
        )}
      </div>
    );
  }

  return null;
};

export default SopResult;
